import kebabcase from 'lodash.kebabcase'

export const isEmptyOrNullOrUndefined = (value: string | null | undefined) =>
  value === '' || value === null || value === undefined

export const not = (predicateFn: (value: string) => boolean) => (value: string) => !predicateFn(value)

/**
 * Encodes a string to base64url format
 *
 *  the '+' and '/' characters of standard Base64 are respectively replaced by '-' and '_',
 *
 * https://datatracker.ietf.org/doc/html/rfc4648#page-7
 * @param stringToEncode
 * @returns string
 */
export const encodeStringToBase64url = (stringToEncode: string) => {
  const base64string = btoa(stringToEncode)
  const slashRE = new RegExp(/\//, 'g')
  const plusRE = new RegExp(/\+/, 'g')
  const equalRE = new RegExp(/=/, 'g')

  return base64string.replace(slashRE, '_').replace(plusRE, '-').replace(equalRE, '')
}

/**
 * @param strings Array of strings, empty strings, undefined and or nulls
 * @param delimiter Optional character to delimit the strings in the result string
 * @returns The strings that are not null, empty or undefined, appended and delimited by the delimiter.
 */
export const appendStrings = (strings: readonly (string | undefined | null)[], delimiter = ', ') =>
  strings.filter(string => !isEmptyOrWhiteSpacesOrNullOrUndefined(string)).join(delimiter)

/**
 * Convert string to kebab case
 * @param string
 * @returns
 */
export const convertToKebabCase = (string: string, keepCharacter?: string) => {
  if (keepCharacter) {
    return string.split(keepCharacter).map(kebabcase).join('/')
  }
  return kebabcase(string)
}

/**
 * Validate if the string is empty or only contains spaces
 */
export const isEmptyOrOnlyWhiteSpaces = (string: string) => string.replace(/\s/g, '').length === 0

export const isEmptyOrWhiteSpacesOrNullOrUndefined = (value: string | null | undefined) =>
  value === '' || value === null || value === undefined || value.replace(/\s/g, '').length === 0
